var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOngoingPatients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560.82 581.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee7404;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.78,296.03c-25.1,10.93-46.59,28.59-62.21,50.7-1.77,.06-3.56,.12-5.38,.2h-101.88c-110.96-4.66-128.57,22.03-124.48,146.85v87.45H0v-150.82c0-81.1,54.29-135.5,135.27-135.5h197.85c6.74,0,13.3,.38,19.66,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    className: "cls-1",
    d: "M235.06,267.92c-74.19-.04-134.29-60.22-134.25-134.4,.03-53.93,32.31-102.61,81.98-123.63,68.74-27.89,147.08,5.23,174.97,73.97,27.34,67.38-3.9,144.27-70.48,173.5-16.52,7-34.28,10.59-52.22,10.56Zm0-208.9c-41.2,0-74.61,33.4-74.61,74.61s33.4,74.61,74.61,74.61,74.61-33.4,74.61-74.61c-.04-41.19-33.42-74.56-74.61-74.61Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.48,554.27l15.56,26.96h-113.7l56.85-98.47,11.73,20.32c.12-.09,.25-.19,.37-.29,20.61-16.49,33.81-41.86,33.81-70.32,0-.87-.01-1.74-.04-2.6-.54-19.32-7.18-37.13-18.06-51.56-10-13.27-23.6-23.67-39.34-29.79-5.42-2.11-11.08-3.7-16.95-4.73l30.48-52.79c21.43,6.98,40.72,18.7,56.64,33.92,10.8,10.32,20.06,22.26,27.37,35.43,11.86,21.36,18.62,45.95,18.62,72.12,0,50.37-25.04,94.89-63.34,121.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.14,521.84l-30.86,53.44c-21.67-6.33-41.29-17.46-57.64-32.16-10.5-9.43-19.64-20.33-27.11-32.38-14.1-22.73-22.23-49.55-22.23-78.27,0-31.93,10.06-61.51,27.18-85.74,9.89-14,22.14-26.22,36.17-36.08l-15.56-26.94h113.7l-56.85,98.47-11.73-20.32c-20.83,16.47-34.19,41.98-34.19,70.61,0,4.54,.34,9.01,.98,13.37,2.51,16.81,9.65,32.09,20.09,44.52,14.31,17.03,34.82,28.68,58.05,31.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoingPatients);
export default __webpack_public_path__ + "static/media/ongoingPatients.9627ff796fd5968305f58ee8f4712a44.svg";
export { ForwardRef as ReactComponent };